<template>
	<div class="header__dashboard">
        <!-- Header -->
        <div class="header__logo">
            <div class="container">
                <a href="/" class="header__logo-link">
                    <img class="header__logo-image" style="" src="//cdn.shopify.com/s/files/1/0596/1547/7862/files/logo-aozama-blanco.png?width=280&height=132" alt="Aozama">
                </a>
            </div>
        </div>
	</div>
</template>

<script type="text/javascript">
	
import vue from 'vue'
import router from 'vue-router'

vue.use(router)

export default {
    name:'HeaderDashboard',
    referTo: '/header-dashboard'
}

</script>

<style lang="css" scoped>

/* Header */
.header__logo {
    background-color: #1e2d7d;
}

</style>


// WEBPACK FOOTER //
// header-dashboard.vue?f3ea2d46